import { ModalContext } from "app/app";
import { Icon } from "components/lib";
import { Fragment, useContext } from "react";
import styles from "./styles.module.scss";

export function Error() {
  const { modal, setModal } = useContext(ModalContext);

  return (
    <Fragment>
      {modal.name === "error" && (
        <div className={styles.background}>
          <div className={styles.wrapper}>
            <div className={styles.image}>
              <Icon image="alert-circle" size={30} color="#DC2626" />
            </div>
            <div className={styles.title}>{modal.data.title}</div>
            <div className={styles.description}>{modal.data.description}</div>
            <div className={styles.footer}>
              <div className={styles.buttons}>
                <button className={styles.cancel} onClick={() => setModal("")}>
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </Fragment>
  );
}
